import React, { useState } from "react";
import { connect } from "react-redux";

import { Link } from "react-router-dom";
import { makeUserVIP } from "../../store/vipPlan/action";
const MakeUserVip = (props) => {
    const [validity, setValidity] = useState(1);
    const [userId, setUserId] = useState("");
    const [validityType, setValidityType] = useState("day");
    const [errors, setError] = useState({});
    const [php, setPhp] = useState();

    const handleSubmit = () => {
        let formIsValid = true;

        let errors = {};
        if (!userId) {
            formIsValid = false;
            errors["userId"] = "User ID is Required!";
        }
        if (!validity) {
            formIsValid = false;
            errors["validity"] = "Validity is Required!";
        }

        if (!validity || isNaN(validity) || Number(validity) <= 0) {
            formIsValid = false;
            errors["validity"] = "Validity must be greater than 0!";
        }

        if (!formIsValid) {
            setError(errors);
            return;
        } else {
            const _data = {
                uniqueId: userId,
                validity: parseInt(validity, 10),
                validityType,
                php: php ? parseInt(php, 10) : null,
            };

            props.makeUserVIP(_data);
        }
    }

    return (
        <div>
            <div className="page-title">
                <div className="row">
                    <div className="col-12 col-md-6 order-md-1 order-last">
                        <h3 className="mb-3 text-white">Make User VIP</h3>
                    </div>
                    <div className="col-12 col-md-6 order-md-2 order-first">
                        <nav
                            aria-label="breadcrumb"
                            className="breadcrumb-header float-start float-lg-end"
                        >
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <Link to="/admin/dashboard" className="text-danger">
                                        Dashboard
                                    </Link>
                                </li>
                                <li className="breadcrumb-item active" aria-current="page">
                                    Make User VIP
                                </li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
            <div className="modal-body pt-1 px-1 pb-3">
                <div className="d-flex flex-column">
                    <p className="text-gray mb-4">
                        Grant a one-time custom VIP entitlement. This does not create a subscription.
                    </p>
                    <form>
                        <div className="row align-items-center">
                            <div className="col-md-6">
                                <label className="text-gray mb-2">User ID</label>
                                <input
                                    className="form-control"
                                    required=""
                                    placeholder="00000000"
                                    min="0"
                                    value={userId}
                                    onChange={(e) => {
                                        setUserId(e.target.value);
                                        if (!e.target.value) {
                                            return setError({
                                                ...errors,
                                                userId: "User ID is Required!",
                                            });
                                        } else {
                                            return setError({
                                                ...errors,
                                                userId: "",
                                            });
                                        }
                                    }}
                                />
                                {errors.userId && (
                                    <div className="ml-2 mt-1">
                                        {errors.userId && (
                                            <div className="pl-1 text__left">
                                                <span className="text-red">
                                                    {errors.userId}
                                                </span>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="row mt-4">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label className="text-gray mb-2">Validity</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        required=""
                                        placeholder="1"
                                        min="0"
                                        value={validity}
                                        onChange={(e) => {
                                            setValidity(e.target.value);
                                            if (!e.target.value) {
                                                return setError({
                                                    ...errors,
                                                    validity: "Validity is Required!",
                                                });
                                            } else {
                                                return setError({
                                                    ...errors,
                                                    validity: "",
                                                });
                                            }
                                        }}
                                    />
                                    {errors.validity && (
                                        <div className="ml-2 mt-1">
                                            {errors.validity && (
                                                <div className="pl-1 text__left">
                                                    <span className="text-red">
                                                        {errors.validity}
                                                    </span>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label className="text-gray mb-2">Validity Type</label>
                                    <select
                                        className="form-select form-control"
                                        aria-label="Default select example"
                                        value={validityType}
                                        onChange={(e) => {
                                            setValidityType(e.target.value);
                                        }}
                                    >
                                        <option value="day">Day</option>
                                        <option value="month">Month</option>
                                        <option value="year">Year</option>
                                    </select>
                                </div>
                            </div>
                            <div className="col-md-6 mt-4">
                                <div className="form-group">
                                    <label className="text-gray mb-2">PHP</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        placeholder="1"
                                        min="0"
                                        value={php}
                                        onChange={(e) => {
                                            setPhp(e.target.value);
                                        }}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className={"mt-5"}>
                            <button
                                type="button"
                                className="btn btn-round float__right btn-danger"
                                onClick={handleSubmit}
                            >
                                Submit
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default connect(null, { makeUserVIP })(
    MakeUserVip
);
